import React from "react"
import { useSelector } from "react-redux"
import { Card } from "reactstrap"
import CardBody from "reactstrap/lib/CardBody/"
import { getSportsConfig } from "../../utility/constants/sportConfig"
import CommentModal from "./CommentModal"
import styles from "./ScoreCounter.module.scss"
import ScoreViewer from "./ScoreViewer/"
import TeamSection from "./TeamSection/"

const ScoreCounter = () => {
	const spectate = localStorage.getItem("spectate")
	const { rerender, homeTeam, awayTeam } = useSelector((state) => {
		const { homeTeam, awayTeam } = state.players
		return {
			rerender: state.rerender.num,
			homeTeam: {
				teamId: homeTeam.teamId,
				name: homeTeam.name,
				logo: homeTeam.logo,
			},
			awayTeam: {
				teamId: awayTeam.teamId,
				name: awayTeam.name,
				logo: awayTeam.logo,
			},
		}
	})

	const sport = localStorage.getItem("sport")
	const { teamPausesAllowed, teamComments } = getSportsConfig(sport)

	return (
		<Card key={rerender}>
			<CardBody>
				<div className={styles.wrapper}>
					<TeamSection
						team={homeTeam}
						teamPausesAllowed={teamPausesAllowed}
						teamComments={teamComments.map((comment) =>
							comment.replaceAll("${name}", homeTeam?.name ?? "-")
						)}
					/>
					{spectate ? (
						<div
							className={styles.columnFlex}
							style={{ paddingTop: ".5rem" }}
						>
							<ScoreViewer />
						</div>
					) : (
						<div className={styles.columnFlex}>
							<ScoreViewer />
							<CommentModal />
						</div>
					)}
					<TeamSection
						team={awayTeam}
						teamPausesAllowed={teamPausesAllowed}
						teamComments={teamComments.map((comment) =>
							comment.replaceAll("${name}", awayTeam?.name ?? "-")
						)}
						isAwayTeam={true}
					/>
				</div>
			</CardBody>
		</Card>
	)
}

export default ScoreCounter
